import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-other-report',
  templateUrl: './other-report.component.html',
  styleUrls: ['./other-report.component.scss']
})
export class OtherReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
